export default __webpack_public_path__ + "e45e3843c7bb3b4881ea205896eb47e2.jpg";